import { render, staticRenderFns } from "./ProcessAlarmConfirmation.vue?vue&type=template&id=25c66e32&scoped=true"
import script from "./ProcessAlarmConfirmation.vue?vue&type=script&lang=ts"
export * from "./ProcessAlarmConfirmation.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25c66e32",
  null
  
)

export default component.exports